import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, UncontrolledTooltip } from "reactstrap"
import { useHistory } from "react-router"
import { connect } from "react-redux"
import { openWelcome } from "store/actions"
import { isMobile, isMobileOnly } from "react-device-detect"

const vidi = {
  position: "relative",
  height: "100%",
  width: "100vw",
  overflow: "hidden",
  display: "none",
}

const Dashboard = props => {
  const { welcome, onOpenWelcome } = props
  const [newImgSrc, setNewImgSrc] = useState("")
  const [fixState, setFixState] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  const [showFullscreenPrompt, setShowFullscreenPrompt] = useState(false)
  const [userDismissed, setUserDismissed] = useState(false)

  const videoSrc = isMobile
    ? "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Sitero%20Virtual%20Platform%2FWalkthrough%20Video.mp4?alt=media&token=0844c8f6-78f7-441a-8492-3494b9dd0dc4"
    : "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Sitero%20Virtual%20Platform%2FWalkthrough%20Video.mp4?alt=media&token=0844c8f6-78f7-441a-8492-3494b9dd0dc4"
  const imgSrc = isMobile
    ? "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Sitero%20Virtual%20Platform%2FClick%20to%20enter.png?alt=media&token=c41c950f-b82c-443e-b78c-1ea6391497fc"
    : "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Sitero%20Virtual%20Platform%2FClick%20to%20enter.png?alt=media&token=c41c950f-b82c-443e-b78c-1ea6391497fc"

  const history = useHistory()
  
  function tAdd() {
    const body = document.body
    body.classList.add("vertical-collpsed")
    body.classList.add("sidebar-enable")
  }

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    }
  }

  const handleEnterFullscreen = () => {
    setShowFullscreenPrompt(false)
    setUserDismissed(false)
    toggleFullscreen()
  }

  const handleDismissPrompt = () => {
    setShowFullscreenPrompt(false)
    setUserDismissed(true)
  }

  // Fullscreen detection and prompt logic
  useEffect(() => {
    const isFullscreen = document.fullscreenElement || 
                        document.mozFullScreenElement || 
                        document.webkitFullscreenElement

    if (!isFullscreen) {
      setShowFullscreenPrompt(true)
    }

    const handleFullscreenChange = () => {
      const isNowFullscreen = document.fullscreenElement || 
                              document.mozFullScreenElement || 
                              document.webkitFullscreenElement

      if (!isNowFullscreen && !userDismissed) {
        setTimeout(() => {
          setShowFullscreenPrompt(true)
        }, 300)
      }
    }

    document.addEventListener('fullscreenchange', handleFullscreenChange)
    document.addEventListener('mozfullscreenchange', handleFullscreenChange)
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange)
    document.addEventListener('msfullscreenchange', handleFullscreenChange)

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange)
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange)
      document.removeEventListener('msfullscreenchange', handleFullscreenChange)
    }
  }, [userDismissed])

  useEffect(() => {
    const checkScreenSize = () => {
      if (window.innerWidth < 500) {
        window.location.reload();
        document.getElementById("skip1").style.display = "none"
        setNewImgSrc(
          "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/apple%20virtual%20platform%2FRotate%20Your%20Phone.gif?alt=media&token=797900cb-990e-466a-9182-c675914732ab"
        )
        setFixState(!fixState);
      } else {
        document.getElementById("skip1").style.display = "block"
        setNewImgSrc(
          "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Sitero%20Virtual%20Platform%2FClick%20to%20enter.png?alt=media&token=c41c950f-b82c-443e-b78c-1ea6391497fc"
        )
        setFixState(!fixState);
      }
    }

    checkScreenSize()
    window.addEventListener("resize", checkScreenSize)

    return () => {
      window.removeEventListener("resize", checkScreenSize)
    }
  }, [])

  const loader = document.querySelector(".loader")

  useEffect(() => {
    if (loader) {
      loader.classList.add("loader--hide")
    }
  }, [])

  return (
    <React.Fragment>
      {/* Fullscreen Prompt Modal */}
      {showFullscreenPrompt && (
       <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          // backgroundColor: 'rgba(0, 0, 0, 0.8)',
          background: "url('https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Sitero%20Virtual%20Platform%2FLeaderboard.jpg?alt=media&token=c4b8292f-2c1d-454b-949b-b5f88fbb523b')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #310147, #13011d, #240069)',
            padding: '30px 80px',
            borderRadius: '20px',
            maxWidth: '400px',
            textAlign: 'center',
            // boxShadow: '0 0 2px 4px #d0b24f55',
            border: "3px solid #fde490" ,
            borderBottom: "3px solid #966223",
            borderLeft: "3px solid #966223"
          }}>
            <i className="bx bx-fullscreen" style={{ fontSize: '48px', color: '#d0b24f', marginBottom: '15px' }}></i>
            {/* <h4 style={{ marginBottom: '15px', color: '#d0b24f' }}>Enable Fullscreen Mode?</h4> */}
            <h6 style={{ marginBottom: '25px', fontSize: "17px", color: '#ffffff' }}>
              Best viewed in full screen <h4 style={{ color: '#d0b24f' }}> Please Proceed</h4>
            </h6>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button 
                onClick={handleEnterFullscreen}
                className="btn applebtn"
              >
                <i className="bx bx-check me-1"></i>
                OK 
                {/* <i className="bx bx-fullscreen ms-1 me-1" />  */}
              </button>
              {/* <button 
                onClick={handleDismissPrompt}
                className="btn btn-secondary"
                style={{ minWidth: '120px' }}
              >
                Maybe Later
              </button> */}
            </div>
          </div>
        </div>
      )}

      <div style={{ padding: 0 }} className="page-content">
        <MetaTags>
          <title>Sitero 2025</title>
        </MetaTags>

        <Container style={{ padding: 0 , display: "block", overflow: "hidden"}} fluid>
          <img
            onClick={() => history.push("/page/lobby")}
            id="img-1"
            alt=""
            src={fixState?newImgSrc:imgSrc}
            width="100%"
            loading="lazy"
          />
          
          {/* <img
            src={imgSrc} // Default fallback image
            srcSet={`
    https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/apple%20virtual%20platform%2FRotate%20Your%20Phone.gif?alt=media&token=797900cb-990e-466a-9182-c675914732ab 500w,
    ${imgSrc} 501w
  `}
            sizes="(max-width: 500px) 100vw, 50vw"
            style={{
              top: "0%",
              width: "100%",
              position: "absolute",
              height: "100%",
              left: "0%",
              objectFit: "cover",
            }}
            loading="eager" 
          /> */}

          <div style={{display: "none"}}>
            <UncontrolledTooltip target="skip1">Skip</UncontrolledTooltip>
            <div
              id="skip1"
              // onClick={() => { history.push("/page/lobby") }} //addedy
              onClick={() => {
                //change here for redirection after on click on skip
                history.push("/page/lobby")
              }}
                style={{
                  cursor: "pointer",
                  display: "none !mportant",
                  justifyContent: "center",
                  alignItems: "center",
                  transform: "skew(0deg, 0deg)",
                  position: "absolute",
                  width: "fit-content",
                  fontSize: "1.1rem",
                  top: "5%",
                  left: "80%",
                  zIndex: "3",
                  padding: "0 1.5%",
                  position: "fixed",
                  borderRadius: "10px",
                  border: "2px solid #fde490",
                  borderBottom: "2px solid #966223",
                  borderLeft: "2px solid #966223",
                  color: isHovered ? "#fff" : "white",
                  boxShadow: isHovered ? "0 0 5px 1px gold" : "0 0 5px 1px transparent",
                  background: isHovered 
                    ? "linear-gradient(45deg, #966223, #d0b24f, #fde490)" 
                    : "linear-gradient(45deg, #7b4f1a79, #c7a9446d, #fde8a56a)",
                  transition: "all 0.1s ease",
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
              <span
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }} 
              >
                SKIP{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="40px"
                  viewBox="0 -960 960 960"
                  width="40px"
                  fill="#fff"
                >
                  <path d="M521.33-480.67 328-674l47.33-47.33L616-480.67 375.33-240 328-287.33l193.33-193.34Z" />
                </svg>
              </span>
            </div>
          </div>
          <div>
             {/* <UncontrolledTooltip target="click2enter">
              Click to Enter
            </UncontrolledTooltip> */}

            <div
              id="click2enter"
              // onClick={() => { history.push("/page/lobby") }} //addedy
              onClick={() => {
                // onOpenWelcome();
                document.getElementById("vid-1").style.display = "flex"
                document.getElementById("img-1").style.display = "none"
                document.getElementById("vid-1").play()
              }}
              style={{
                cursor: "pointer",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                transform: "skew(0deg, 0deg)",
                position: "absolute",
                width: "100%",
                height: "100%",
                top: "0%",
                left: "0%",
              }}
            ></div>
          </div>

          <video
            preload="auto"
            id="vid-1"
            src={videoSrc}
            style={vidi}
            autostart="false"
            onLoadStart={() => {
              tAdd()
            }}
            onEnded={() => {
              history.push("/page/lobby")
            }}
          ></video>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = ({ agenda }) => ({
  welcome: agenda.welcome,
})

const mapDispatchToProps = dispatch => ({
  onOpenWelcome: () => dispatch(openWelcome()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)